export default __webpack_public_path__ + "static/media/About0.f5d98bcd.jpg";